import React, {Component} from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import './style.css'
import NRTBulletList from "../../components/_common/BulletList"
import NRTBullet from "../../components/_common/BulletList/Bullet"
import NRTCardStack from "../../components/_common/CardStack"
import MainTemplate from "../../components/_common/_containers/AppContainer/index"
import FullWidthContainer from "../../components/_common/_containers/FullWidthContainer/FullWidthContainer"
import ContentContainer from "../../components/_common/_containers/ContentContainer"
import CourseHeader from "../../components/_courses/CourseHeader"
import AuthenticateStep from "./_partials/AuthenticateStep"
import GuestsStep from "./_partials/GuestsStep"
import PaymentStep from "./_partials/PaymentStep"
import ResponsibleStep from "./_partials/ResponsibleStep"
import ConfirmationStep from './_partials/ConfirmationStep'
import MCLoading from '../../components/_minha-central/Loading';
import MCErrorMsg from '../../components/_common/ErrorMsg';
import {getParsedPriceValues} from "../../helpers/price";
import SaleRequests from "../../requests/sale-requests"
import tryLogin from "../../_functions/try-login"
import PersonRequests from "../../requests/person-requests"
import MCRequests from "../../requests/mc-requests"
import doSale from "./_functions/do-sale"
import Ipag from "./_functions/ipag"
import {approveSale, cancelSale} from "./_functions/change-sale-status"
import {PaymentMethodsEnum} from "../../enums/PaymentMethodsEnum";


const scrollToComponent = process.env.NODE_ENV === 'test' ? () => null : require('react-scroll-to-component')


class SalePage extends Component {

    static AUTHENTICATE_STEP = 'login'
    static RESPONSIBLE_STEP = 'responsavel'
    static GUESTS_STEP = 'participantes'
    static PAYMENT_STEP = 'pagamento'
    static CONFIRMATION_STEP = 'confirmacao'
    static INVALID_RESPONSIBLE_MESSAGE = 'O responsável pela compra deve ser uma pessoa física.'

    state = {
        activeCard: 0,
        schema: null,
        saleComplete: false,
        awaiting: true,
        error: null,
        productData: {},
        releaseData: {},
    }


    static getDerivedStateFromProps(nextProps) {

        const {match} = nextProps
        const {params} = match
        const {step, releaseCode} = params
        let activeCard = null


        switch (params.step) {
            case SalePage.AUTHENTICATE_STEP:
                activeCard = (nextProps.context.person) ? 1 : 0
                break
            case  SalePage.RESPONSIBLE_STEP:
                activeCard = 1
                break
            case  SalePage.GUESTS_STEP:
                activeCard = 2
                break
            case SalePage.PAYMENT_STEP:
                activeCard = 3
                break
            case SalePage.CONFIRMATION_STEP:
                activeCard = 4
                break
        }


        return {
            schema: nextProps.context.credentials.schema,
            activeCard,
            step,
            releaseCode,

        }
    }


    componentDidMount() {
        const {context} = this.props

        if (!context.saleCourseData) {
            console.info('Nao selecionou nenhum curso.')
            this.getCourseData(this.props.match.params.releaseCode)
        }
    }


    getCourseData(code) {

        this.props.getCourseData(code)
            .then(release => {
                this.selectRelease(release)
                this.setState({awaiting: false})
            })
            .catch(error => {
                console.error(error, 'ERROR')
                this.setState({
                    awaiting: false,
                    error: 'Ocorreu um erro ao tentar obter as informações desta turma.'
                })

            })

    }


    formatReleaseNumber = (number) => {
        return `${number.slice(4)} / ${number.slice(0, 4)}`
    }


    selectRelease(release) {
        const releaseData = {}
        releaseData.title = `${this.formatReleaseNumber(release.number)} - ${release.name}`
        releaseData.image = release.mainImageUrl || release.product.mainImageUrl
        releaseData.authors = release.personOwners
        releaseData.description = `${release.description} ${release.product.description}`
        releaseData.startDate = release.startDate //? moment(release.startDate).format('DD/MM/YYYY') : null
        releaseData.startTime = release.startTime //? moment(release.startTime).format('hh:mm') : null
        releaseData.endDate = release.endDate //? moment(release.endDate).format('DD/MM/YYYY')
        releaseData.endTime = release.endTime //? moment(release.endTime).format('hh:mm')
        releaseData.workload = release.workload

        // PRECO
        const priceValues = getParsedPriceValues(release.price)

        this.setState({
            release,
            releaseData: {
                ...releaseData,
                ...priceValues
            }
        }, () => {
            this.props.context.set({
                saleRelease: this.state.release,
                saleCourseData: this.state.releaseData
            })
        })
    }


    componentDidUpdate() {

        const step = this.props.match.params.step
        if (
            step !== SalePage.RESPONSIBLE_STEP &&
            step !== SalePage.AUTHENTICATE_STEP
        ) {
            this.validateSaleResponsible()
        }


        scrollToComponent(
            this.formContainer,
            {
                offset: 10,
                align: 'middle',
                duration: 500
            }
        )
    }


    goToAuthenticateStep = () => this.props.history.push(`/venda/${this.state.releaseCode}/${SalePage.AUTHENTICATE_STEP}`)
    goToResponsibleForm = () => this.props.history.push(`/venda/${this.state.releaseCode}/${SalePage.RESPONSIBLE_STEP}`)
    goToGuestsStep = () => this.props.history.push(`/venda/${this.state.releaseCode}/${SalePage.GUESTS_STEP}`)
    goToPaymentStep = () => this.props.history.push(`/venda/${this.state.releaseCode}/${SalePage.PAYMENT_STEP}`)

    goToHome = () => this.props.history.push('/')

    goToConfirmationStep = (freeCourse = false ) => {

        return ()=>{
            if (freeCourse) {
                this.props.context.set({
                    salePayment:{
                        saleValue:0,
                        unitValue: 0,
                        installmentNumber: 1,
                        installmentValue: 0,
                        paymentMethod : PaymentMethodsEnum.BANK_BILLET.code ,

                    }
                })
            }

            this.props.history.push(`/venda/${this.state.releaseCode}/${SalePage.CONFIRMATION_STEP}`)
        }
    }


    onSaleComplete = () => {
        this.setState({saleComplete: true})
    }


    validateSaleResponsible() {
        const responsibleIsLegal = _.get(this.props.context, 'saleResponsible.isLegal')
        const hasResponsible = !!_.get(this.props.context, 'saleResponsible.code')

        if (responsibleIsLegal || !hasResponsible) {

            if (responsibleIsLegal) {
                this.props.context.set({
                    toastMessage: {
                        content: SalePage.INVALID_RESPONSIBLE_MESSAGE
                    }
                })
                this.props.context.logout()
            }


            return this.goToAuthenticateStep()
        }

    }

    goToForgotPassword = () => this.props.history.push('/login/esqueceu-senha')


    render() {

        const {
            activeCard,
            schema,
            awaiting,
            error
        } = this.state

        const {context} = this.props


        if (error)
            return <MCErrorMsg>{error}</MCErrorMsg>

        if (awaiting && !context.saleCourseData)
            return (<MCLoading/>)


        const {saleCourseData} = context
        const {sightValue } = saleCourseData

        const freeCourse =  sightValue === 0



        return (
            <MainTemplate className={'nrt-sale-page'}  {...this.props}>
                <FullWidthContainer>
                    <CourseHeader
                        title={context.saleCourseData.title}
                        authorNames={!!context.saleCourseData.authors ? context.saleCourseData.authors.map(a => a.name).join(',') : ''}
                        startDate={context.saleCourseData.startDate}
                        endDate={context.saleCourseData.endDate}
                        startTime={context.saleCourseData.startTime}
                        endTime={context.saleCourseData.endTime}
                        image={context.saleCourseData.image}
                        workload={context.saleCourseData.workload}
                    />

                    <ContentContainer center className={'nrt-sale-content'}>

                        <div className={'sale-bullet-list'}>
                            <NRTBulletList>
                                <NRTBullet bulletNumber={[0, 1]}
                                           title={'Cadastro'}
                                           activeBullet={activeCard} content={'1'}/>

                                <NRTBullet bulletNumber={2}
                                           title={'Adicionar participantes'}
                                           activeBullet={activeCard} content={'2'}/>

                                {
                                    !freeCourse &&
                                    <NRTBullet bulletNumber={3}
                                               title={'Dados do pagamento'}
                                               activeBullet={activeCard} content={'3'}/>

                                }

                                <NRTBullet bulletNumber={4}
                                           title={'Confimação'}
                                           activeBullet={activeCard}
                                           content={freeCourse ? '3' : '4'}/>
                            </NRTBulletList>
                        </div>

                        <div className={'nrt-sale-form-container'} ref={(e) => {
                            this.formContainer = e
                        }}>
                            <NRTCardStack activeCard={activeCard}>
                                <AuthenticateStep
                                    schema={schema}
                                    context={context}
                                    tryLogin={tryLogin(PersonRequests.search)}
                                    goToNextStep={this.goToResponsibleForm}
                                    goToForgotPassword={this.goToForgotPassword}
                                />

                                <ResponsibleStep
                                    goToNextStep={this.goToGuestsStep}
                                    context={context}
                                />

                                <GuestsStep
                                    goToPreviousStep={this.goToResponsibleForm}
                                    goToNextStep={ freeCourse ?
                                        this.goToConfirmationStep(freeCourse) : this.goToPaymentStep}
                                    context={context}
                                    savePerson={PersonRequests.save}
                                />


                                {
                                   !freeCourse &&
                                    <PaymentStep
                                        goToPreviousStep={this.goToGuestsStep}
                                        goToNextStep={this.goToConfirmationStep()}
                                        getIpagApiKey={() => MCRequests.getSystemConfig('PARAM_PAYMENT_PARTNER_AUTH_TOKEN')}
                                        getIpagId={() => MCRequests.getSystemConfig('PARAM_PAYMENT_PARTNER_AUTH_EMAIL')}
                                        doSale={doSale(SaleRequests.doSale)}
                                        doPaymentWithIpag={Ipag.doPayment}
                                        approveSale={approveSale}
                                        cancelSale={cancelSale}
                                        context={context}
                                    />


                                }


                                <ConfirmationStep
                                    goToPreviousStep={this.goToPaymentStep}
                                    goToHome={this.goToHome}
                                    onSaleComplete={this.onSaleComplete}
                                    context={context}
                                    doSale={SaleRequests.doSale}
                                />
                            </NRTCardStack>
                        </div>
                    </ContentContainer>
                </FullWidthContainer>
            </MainTemplate>
        )
    }
}

SalePage.propTypes = {
    getCourseData: PropTypes.func.isRequired,
}

export default SalePage



// WEBPACK FOOTER //
// ./src/_pages/Sale/index.js